export const HEADER_NOTIFICATION_DESKTOP_CLASS = 'hidden xl:block';

export const HEADER_NOTIFICATION_MOBILE_CLASS = 'xl:hidden';

export const NOTIFICATION_TOGGLE_BASE_CLASS =
  'focus-visible:ring-primary/50 flex h-8 w-12 shrink-0 items-center rounded-full border p-1 transition-colors focus-visible:ring-2 focus-visible:outline-none';

export const NOTIFICATION_TOGGLE_ENABLED_CLASS =
  'border-on-surface bg-on-surface justify-end';

export const NOTIFICATION_TOGGLE_DISABLED_CLASS =
  'border-outline bg-surface-variant justify-start';

export const NOTIFICATION_PREFERENCE_ROW_WITH_DIVIDER_CLASS =
  'border-outline-variant flex gap-4 border-b px-2 py-4 first:pt-0';

export const NOTIFICATION_PREFERENCE_LAST_ROW_CLASS = 'flex gap-4 px-2 pt-4';
